import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthenticationService } from './auth/authentication.service';
import { NavigationService } from './navigation/navigation.service';
import { LoggerService } from './logger/logger.service';
import { HomeService } from './home/home.service';
import { environment } from '@env/environment';
import { Router } from '@angular/router';

const log = new LoggerService('APP COMPONENT');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})

export class AppComponent implements OnInit {

  public startupPathname: string = '/';

  constructor(
    private router: Router,
    private navigationService: NavigationService,
    private homeService: HomeService,
    private authenticationService: AuthenticationService
  ) {
    //log.debug('[constructor] Location', location.pathname)
    if (location.pathname !== '/' && location.pathname !== '/home/login')
      this.startupPathname = location.pathname;

    //log.debug('[constructor] Setting location pathname: ', this.startupPathname)
  }


  async ngOnInit() {
    try {
      this.satEpioneCoreMode();
      if (environment.production) LoggerService.enableProductionMode();

      const isLoggedIn: boolean = await this.authenticationService.isLoggedIn();
      await this.startupHomeRoutes();
      await this.navigationService.startupNavigationService({ isLoggedIn });
      log.debug('[ngOnInit] Navigation config: ', this.navigationService.routerConfiguration);
      this.router.resetConfig(this.navigationService.routerConfiguration);
      this.authenticationService.navigationTreeGenerated = true;

      if (this.startupPathname !== '/' && this.startupPathname !== '/home/login') {
        this.router.navigate([this.startupPathname]);
      }

      if (this.startupPathname === '/') {
        this.router.navigate(['/epione/home'])
      }
      this.authenticationService.refreshSession();
    } catch (err) {
      throw err;
    }
  }

  private async startupHomeRoutes() {
    try {

      const apiResponse = await this.homeService.getHomeNavigationData();

      if (apiResponse.state === 'success') {
        const homeData = apiResponse.data[0];
        const navDataRoutes = this.navigationService.generateNavigationDataRoutesFromToolsArray(homeData.remoteEntry, homeData.exposedModule, homeData.tools);
        this.navigationService.homeNavigationRoutes = this.navigationService.recursiveRouteGenerator(homeData.remoteEntry, homeData.exposedModule, navDataRoutes);
      }

      if (apiResponse.state === 'error') {
        throw new Error(apiResponse.message);
      }
    } catch (err) {
      throw err;
    }
  }

  private satEpioneCoreMode() {
    localStorage.setItem('epioneCoreMode', environment.EPIONE_CORE_MODE);
  }
}
